module.exports={
	"Form": "ProjectEditManifest",
	"Scope": "Project-Edit",
	"Descriptors":
	{
		"ProjectDetails.IDProject":
		{
			"Name": "Project ID",
			"Hash": "ProjectEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ProjectEditIdentity",
				"Group": "ProjectEditIdentity"
			}
		},
		"ProjectDetails.GUIDProject":
		{
			"Name": "GUID",
			"Hash": "ProjectEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ProjectEditIdentity",
				"Group": "ProjectEditIdentity"
			}
		},
		"ProjectDetails.Name":
		{
			"Name": "Project Name",
			"Hash": "ProjectEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "ProjectEditIdentity",
				"Group": "ProjectEditIdentity"
			}
		},
		"ProjectDetails.Status":
		{
			"Name": "Status",
			"Hash": "ProjectEdit-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 3,
				"Section": "ProjectEditConfig",
				"Group": "ProjectEditConfig"
			}
		},
		"ProjectDetails.ExternalProjectID":
		{
			"Name": "External Project ID",
			"Hash": "ProjectEdit-ExternalID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 3,
				"Section": "ProjectEditConfig",
				"Group": "ProjectEditConfig"
			}
		},
		"ProjectDetails.IDOrganization":
		{
			"Name": "Prime Contractor",
			"Hash": "ProjectEdit-IDOrganization",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Picker",
				"Entity": "Organization",
				"SearchFields": [ "Name", "Type", "City", "State", "VendorCode" ],
				"Row": "2",
				"Width": 3,
				"Section": "ProjectEditConfig",
				"Group": "ProjectEditConfig"
			}
		},
		"ProjectDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "ProjectEdit-IDContract",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Picker",
				"Entity": "Contract",
				"SearchFields": [ "Name", "Description", "Status", "PrimaryProjectNumber", "ExternalContractID" ],
				"Row": "2",
				"Width": 3,
				"Section": "ProjectEditConfig",
				"Group": "ProjectEditConfig"
			}
		},
		"ProjectDetails.InitialContractAmount":
		{
			"Name": "Initial Contract Amount",
			"Hash": "ProjectEdit-InitialContractAmount",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "3",
				"Width": 3,
				"Section": "ProjectEditFinancials",
				"Group": "ProjectEditFinancials"
			}
		},
		"ProjectDetails.CostPerDay":
		{
			"Name": "Cost / Day",
			"Hash": "ProjectEdit-CostPerDay",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "3",
				"Width": 3,
				"Section": "ProjectEditFinancials",
				"Group": "ProjectEditFinancials"
			}
		},
		"ProjectDetails.OriginalContractedDays":
		{
			"Name": "Original Contracted Days",
			"Hash": "ProjectEdit-OriginalContractedDays",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "3",
				"Width": 3,
				"Section": "ProjectEditFinancials",
				"Group": "ProjectEditFinancials"
			}
		},
		"ProjectDetails.ContractedDays":
		{
			"Name": "Contracted Days",
			"Hash": "ProjectEdit-ContractedDays",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "3",
				"Width": 3,
				"Section": "ProjectEditFinancials",
				"Group": "ProjectEditFinancials"
			}
		},
		"ProjectDetails.Description":
		{
			"Name": "Description",
			"Hash": "ProjectEdit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "ProjectEditDescription",
				"Group": "ProjectEditDescription"
			}
		},
		"ProjectDetails.CustomProperties":
		{
			"Name": "Custom Properties",
			"Hash": "ProjectEdit-CustomProperties",
			"DataType": "Object",
			"PictForm":
			{
				"InputType": "ObjectEditor",
				"Row": "4",
				"Width": 12,
				"Section": "ProjectEditCustomProperties",
				"Group": "ProjectEditCustomProperties"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ProjectEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ProjectEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Configuration",
			"Hash": "ProjectEditConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Configuration",
					"Hash": "ProjectEditConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Schedule & Financials",
			"Hash": "ProjectEditFinancials",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Schedule & Financials",
					"Hash": "ProjectEditFinancials",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Description",
			"Hash": "ProjectEditDescription",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Description",
					"Hash": "ProjectEditDescription",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Custom Properties",
			"Hash": "ProjectEditCustomProperties",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Custom Properties",
					"Hash": "ProjectEditCustomProperties",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
